import gql from "graphql-tag";

/*
 * Find a product by it's primary key (as known by magento).
 *
 * Do NOT change the "operation name", as it's used for caching purposes.
 */
const GetProductsPriceByGroupId = gql`
  query GetProductsPriceByGroupId($groupId: Int!, $ids: [String]) {
    productsPriceByGroup(groupId: $groupId, ids: $ids) {
      id
      groupId
      productId
      actualPrice
      originalPrice
    }
  }
`;

export default GetProductsPriceByGroupId;
